<template>
  <div>
    <v-container grid-list-xs>
      <v-layout row wrap>
        <v-flex xs12 md2>
          
        </v-flex>
        <v-flex xs12 md8>
          <v-card class="elevation-12 pa-4">
            <v-layout row wrap>
              <v-flex xs8>
                <v-layout row wrap>
                  <v-flex xs12 style="font-size:26px;font-weight:900;" class="text-uppercase">
                    Dr. Maen K Househ
                  </v-flex>
                  <v-flex xs12 style="font-size:12px;font-weight:700;" class="text-uppercase primary--text">
                    Swiss Army Knife of a Startup
                  </v-flex>
                  <v-flex xs12 style="font-size:14px;font-weight:500;" class="">
                    An honor listed MD and a Self Taught Full Stack Developer!
                  </v-flex>
                  <v-flex xs12 style="font-size:14px;font-weight:300;" class="">
                    Graduated from Med School in 2012 (honor listed through the 6 years) ranked 4th out of 748. Then Moved swiftly to Germany to start my first company and grow it up to 2017 generating a revenue of 1.4 million Euros. Then I decided to leave to become a full stack developer all the way self taught!
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs4 class="text-xs-center">
                <img width="70%" src="https://maenupdates.web.app/coding.png">
              </v-flex>
              <v-flex xs12 v-for="(item, i) in items" :key="i">
                <v-layout row wrap class="py-1">
                  <v-flex xs1>
                    <v-icon right>done</v-icon>
                  </v-flex>
                  <v-flex xs11>
                    {{item.text}}
                  </v-flex>
                  <v-flex xs12 v-if="item.items.length" v-for="(sub, k) in item.items" :key="k">
                    <v-layout row wrap>
                      <v-flex xs1>
                      </v-flex>
                      <v-flex xs1>
                        <v-icon right>done</v-icon>
                      </v-flex>
                      <v-flex xs10>
                        {{sub}}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 py-3 class="title">
                GitHub contributions
              </v-flex>
              <v-flex xs12>
                <img src="https://ghchart.rshah.org/0d47a1/maenkhouseh" width="100%" alt="Maen K Househ Github chart" />
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 md2>
          
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { firebase, db, auth, perf, store, storageRef } from '@/fb'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, between, email, numeric, alpha } from 'vuelidate/lib/validators'
import { isEmail } from '@/validators'
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import axios from 'axios';
import urlMetadata from 'url-metadata';
import FileType from 'file-type';
import {makeTokenizer} from '@tokenizer/http';

const api = `https://us-central1-green-way-b58d5.cloudfunctions.net/main`
const headers = {'Accept': 'application/json'};
// import countries from '@/countries'
let prefix, cc


export default {
  mixins: [validationMixin],
   components: {
  },
  props:{
    superAdmin:{},
    userData:{},
    userName:{},
  },
  data () {
    return {
      items:[
        {
          text:`Experience as a Full Stack Development worked with:`, 
          items:[
            `Server, Network, and Hosting Environment: Firebase & Linux, DNS, Proxy (cloud & residential)`,
            `Data: Business logic oriented use of SQL, nonSQL: Firebase.`,
            `Frameworks: Business logic oriented use of SQL, nonSQL: Firebase.`,
            `Languages: HTML5, CSS3, JavaScript, jQuery, PHP, .Liquid, SCSS, Shell Script.`,
            `Firebase as a Backend (storage, database, cloud functions)`,
          ]
        },
        {text:`Experienced in Using Adobe Stack, Photoshop, illustrator, InDesign.`, items:[]},
        {text:`Fully Experienced in Web Design & Development Using Wordpress CMS.`, items:[]},
        {text:`Experienced in Web Design & Development Using .liquid for ecommerce platform Shopify and Thinkific.`, items:[]},
        {text:`Worked with 100s of Libraries and reusable Design and Development Frameworks.`, items:[]},
        {text:`Experienced in building most complex Sale Funnels & Web Forms with conditional Fields, Logic Dependant Form Flow, Required Fields, Proper Field Warnings, Custom Forms integration with various APIs (Trello, various CRMs, SMS gateways, Email Marketing Software).`, items:[]},
        {text:`Experienced in building custom CRM based on business model and process using out of the box solutions such as Zoho Creator / Airtable / HubSpot or more complex completely custom built web based CRMs.`, items:[]},
        {text:`Experienced in design & development of Email Templates used for Notifications, confirmation, marketing, as well as newsletters.`, items:[]},
        {text:`Used MailChimp / Campaign Monitor / MailGun / Mandrill / SendGrid / Aweber / GetResponse / Constant Contact Softwares to Manage 100K+ Email subscribers, Notifications, Campaigns, and Newsletters.`, items:[]},
        {text:`Experienced in integrating numerous Web applications through either SaaS based methods or using native APIs.`, items:[]},
        {text:`Worked on integrations involving Gmail, Gsheets, GDocuments, Google Calendar, Facebook Pages, Facebook Leads, Trello, Airtable, Zoho CRM, Zoho invoice, Slack, MailChimp, Typeform, HubSpot, Google Forms, WordPress, Woocommerce, JotForm, Shopify, PayPal, Zoom, ChatFuel, Google Analytics, Databox, Twilio, Clearbit, Hunter, Drift, Crisp, FreshDesk, MySQL, Firebase, Eventbrite, Google Drive, Dropbox, Cloud Convert, One Signal, Pushbullet, Stripe, Braintree, MessageBird, 46elks, Calendly, VCita, Acuity Scheduling, Bitly, GoToWebinar, Disqus.. etc.`, items:[]},
      ]
    }
  },
  methods: {
    
  },
  computed:{
    

  },
  validations: {
    
  },
  watch: {
    
  },
  async created() {
  },
  mounted() {
    
    
  },
  destroyed(){
  }
}
</script>
<style>

</style>
